// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISpendLimitTypePropertyDto
 */
export interface ISpendLimitTypePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof ISpendLimitTypePropertyDto
     */
    spend_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof ISpendLimitTypePropertyDto
     */
    spend_limit_type?: ISpendLimitTypePropertyDtoSpendLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ISpendLimitTypePropertyDto
     */
    irs_limit_type?: ISpendLimitTypePropertyDtoIrsLimitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ISpendLimitTypePropertyDto
     */
    spend_limit_type_state?: ISpendLimitTypePropertyDtoSpendLimitTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ISpendLimitTypePropertyDtoSpendLimitTypeEnum {
    UNLIMITED = 'UNLIMITED',
    IRS_LIMIT = 'IRS_LIMIT',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum ISpendLimitTypePropertyDtoIrsLimitTypeEnum {
    HCFSA_MAX = 'HCFSA_MAX',
    HSA_MAX = 'HSA_MAX',
    DCAP_MAX = 'DCAP_MAX',
    TRANSIT_MAX = 'TRANSIT_MAX',
    PARKING_MAX = 'PARKING_MAX',
    HCFSA_EE_ER_MAX = 'HCFSA_EE_ER_MAX'
}
/**
* @export
* @enum {string}
*/
export enum ISpendLimitTypePropertyDtoSpendLimitTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ISpendLimitTypePropertyDto interface.
 */
export function instanceOfISpendLimitTypePropertyDto(value: object): value is ISpendLimitTypePropertyDto {
    return true;
}

export function ISpendLimitTypePropertyDtoFromJSON(json: any): ISpendLimitTypePropertyDto {
    return ISpendLimitTypePropertyDtoFromJSONTyped(json, false);
}

export function ISpendLimitTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISpendLimitTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'spend_limit': json['spend_limit'] == null ? undefined : json['spend_limit'],
        'spend_limit_type': json['spend_limit_type'] == null ? undefined : json['spend_limit_type'],
        'irs_limit_type': json['irs_limit_type'] == null ? undefined : json['irs_limit_type'],
        'spend_limit_type_state': json['spend_limit_type_state'] == null ? undefined : json['spend_limit_type_state'],
    };
}

export function ISpendLimitTypePropertyDtoToJSON(json: any): ISpendLimitTypePropertyDto {
    return ISpendLimitTypePropertyDtoToJSONTyped(json, false);
}

export function ISpendLimitTypePropertyDtoToJSONTyped(value?: ISpendLimitTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spend_limit': value['spend_limit'],
        'spend_limit_type': value['spend_limit_type'],
        'irs_limit_type': value['irs_limit_type'],
        'spend_limit_type_state': value['spend_limit_type_state'],
    };
}

